import {AnimatePresence, motion} from "framer-motion"
import {useEffect, useRef, useState} from "react"
import ChangelogItem from "@/components/changelog/changelog-item"
import useAuth from "@/library/auth/_hook.auth"
import ChangelogFilters from "@/components/changelog/changelog-filters"
import MobileToggle from "@/components/ui-kit/mobile-toggle"
import useChangelog from "@/components/changelog/context/_hook.changelog"
import {useParams} from "@tanstack/react-router"
import ChangelogForm from "@/components/changelog/changelog-form"
import {ProductVersionCreate} from "@/library/api/models/changelog"

export default function ChangelogList() {
    const {refKey} = useParams({strict: false})
    const {currentProduct, products, versions, isLoading, withAuth} = useChangelog()

    const {roles} = useAuth()
    const [creatingNew, setCreatingNew] = useState(false)
    const containerRef = useRef(null)

    const [canCreate, setCanCreate] = useState<boolean>(false)

    useEffect(() => {
        if (withAuth == false)
            return

        setCanCreate(() => roles.includes("CreateChangelogEntry"))
    }, [roles])

    let content = <></>

    if (isLoading)
        content = <motion.div className="alert alert--info">Laster...</motion.div>

    if (!currentProduct && !isLoading)
        content = <motion.div className="alert alert--error">
            Kunne ikke finne produktet: {refKey}
        </motion.div>

    if (versions.length > 0 && currentProduct)
        content = <AnimatePresence mode="popLayout">
            {versions.map((version, i) => {
                version.product = currentProduct

                return <motion.div
                    key={`product-changelog-entry-${version.id}`}
                    initial={{
                        x: -100,
                        opacity: 0
                    }}
                    animate={{
                        x: 0,
                        opacity: 1,
                        transition: {
                            delay: (i ?? 0) * 0.08
                        }
                    }}
                    exit={{
                        x: 100,
                        opacity: 0,
                        zIndex: 3000,
                    }}
                ><ChangelogItem version={version}/></motion.div>
            })}
        </AnimatePresence>

    if (!isLoading && versions.length <= 0 && currentProduct)
        content = <motion.div className="alert alert--info">
            Fant ingen versjoner for produktet <strong>{currentProduct.name}</strong>...
        </motion.div>

    return <motion.div className="product-changes-list"
                       initial="initial"
                       animate="normal"
                       ref={containerRef}
                       style={{overflowX: 'clip'}}>

        <motion.div className="product-versions">
            <AnimatePresence mode="popLayout">
                {(creatingNew && !isLoading && currentProduct) && <motion.div key="create-new-changelog"
                                                                              initial={{
                                                                                  y: -50,
                                                                                  opacity: 0
                                                                              }}
                                                                              animate={{
                                                                                  y: 0,
                                                                                  opacity: 1
                                                                              }}
                                                                              exit={{
                                                                                  y: -100,
                                                                                  opacity: 0,
                                                                                  height: 0
                                                                              }}
                >
                    {/*<CreateChangelogForm closeCallback={() => setCreatingNew(false)}/>*/}
                    <ChangelogForm<ProductVersionCreate>
                        initialValues={{
                            productId: currentProduct?.id ?? -1,
                            branchId: currentProduct?.branches?.last()?.id ?? -1,
                            number: "",
                            released: undefined,
                            //released: new Date().toLocaleDateString("en-CA"),
                            description: undefined,
                            changes: [
                                {title: "", content: ""}
                            ]
                        }}
                        closeCallback={() => setCreatingNew(false)}
                    />
                </motion.div>}
            </AnimatePresence>

            <MobileToggle toggleButtonText="Velg produkt og filtre...">
                <div className="filters">
                    <ChangelogFilters
                        creatingNewState={[creatingNew, setCreatingNew]}
                        canCreate={canCreate}
                        products={products}
                        versions={versions}
                    />
                </div>
            </MobileToggle>
            {content}
        </motion.div>

        <motion.aside className="filters only-xl-and-up"
                      initial={{
                          x: 100,
                          opacity: .5
                      }}
                      animate={{
                          x: 0,
                          opacity: 1,
                          transition: {
                              duration: .15
                          }
                      }}
        >
            <ChangelogFilters
                creatingNewState={[creatingNew, setCreatingNew]}
                canCreate={canCreate}
                products={products}
                versions={versions}
            />
        </motion.aside>
    </motion.div>
}
